<template lang="pug">
  li.table-record.clearfix(
    :class="{'hover':isHover}"
    @mouseover="$emit('mouseover')")
    slot
</template>

<script>
export default {
  name: 'v-tr',
  props: {
    isHover: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped lang="sass">
.table-record
  position: relative
  border-left: none
  border-top: 1px solid #ddd
  &.hover
    >div
      background: #eaeff3
  .table-caption,.table-data
    float: left
    height: 38px
    line-height: 38px
    padding: 0 12px
    border-left: 1px solid #ddd
    &:first-child
      border-left: none
  .table-data
    background-color: #fff
    font-size: 13px
  .table-caption
    font-weight: bolder
    background-color: #e8ecef
    color: #1f1c1c
  &:first-child
    border-top: none
// .table-body .table-record:last-child
//   border-bottom: 1px solid #ddd
</style>



// WEBPACK FOOTER //
// VTr.vue?5d1a60dc